<template>
  <base-widget
    title="Spend"
    class="client-spend"
    :loading="loading"
  >
    <template v-slot:loading>
      <base-skeleton
        no-background
        class="p-4"
      >
        <div class="w-100 d-flex justify-content-between">
          <div
            v-for="n in 4"
            :key="n"
            class="d-flex"
          >
            <div
              class="skeleton__item mr-1 mt-0"
              style="width: 80px; height: 14px"
            />
            <div
              class="skeleton__item mr-1 mt-0"
              style="width: 40px; height: 14px"
            />
          </div>
        </div>
      </base-skeleton>
    </template>

    <template>
      <div
        class="d-flex justify-content-between p-4"
      >
        <div
          v-for="entry in entries"
          :key="`spend_${entry.name}`"
          class="d-flex align-items-center"
        >
          <base-text
            class="client-spend__key"
            size="s"
            light
          >
            {{ entry.name }}
          </base-text>
          <base-text
            class="client-spend__value"
            medium
            size="m"
          >
            {{ entry.value }}
          </base-text>
        </div>
      </div>
    </template>
  </base-widget>
</template>
<script>
export default {

  name: 'ClientSpend',
  props: {
    entries: {
      type: Array,
      default: () => ([]),
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
<style lang="scss" scoped>
.client-spend {
  &__key {
    text-transform: uppercase;
    color: #646464;
    margin-right: 10px;
  }
  &__value{
    font-size: 16px;
  }
}
</style>
